<template>
	<el-row :gutter="20">
		<el-col :span="12">
			<span>报修人 ：</span>
			<span>{{ row.bdRepairName }}</span>
		</el-col>
		<el-col :span="12">
			<span>联系电话 ：</span>
			<span>{{ row.phone }}</span>
		</el-col>
		<el-col :span="12">
			<span>报修时间 ：</span>
			<span>{{ row.repairTime.split("T")[0] }}</span>
		</el-col>
		<el-col :span="12">
			<span>报修项目 ：</span>
			<span>{{ row.repairItem }}</span>
		</el-col>
		<el-col :span="12">
			<span>故障区域 ：</span>
			<span>{{ row.faultArea }}</span>
		</el-col>
		<el-col :span="12">
			<span>故障阐述 ：</span>
			<span>{{ row.faultDesc }}</span>
		</el-col>
		<el-col :span="24">
			<span style="display: flex;align-items: center;">故障照片 ：</span>
			<div style="display: flex;flex-wrap:wrap">
				<img style="margin-left:5px;" v-for="s in row.showPathList"  :src="s" alt="" width="20%">
			</div>
		</el-col>

		<el-col :span="12">
			<span>维修人 ：</span>
			<span>{{ row.assignerName }}</span>
		</el-col>
		<el-col :span="24">
			<span>维修照片 ：</span>
			<div style="display: flex;flex-wrap:wrap">
				<img style="margin-left:5px;" v-for="s in row.showPathList2"  :src="s" alt="" width="20%">
			</div>
		</el-col>
	</el-row>
</template>

<script>
export default {
	props: ["row"]
}
</script>

<style>

</style>
